module.exports = __webpack_public_path__ + "img/SearchIcon.9a35bb51.svg";